import { useChargingFeeDayTypeEnum } from '@services/chargingFee'
import { Select, SelectProps } from '@shared/Form/Select'

export const ChargingFeeDayTypeSelect = (props: SelectProps) => {
  const { data } = useChargingFeeDayTypeEnum()

  return (
    <Select allowClear {...props}>
      {(data || []).map(({ id, label }) => (
        <Select.Option key={id} value={id}>
          {label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ChargingFeeDayTypeSelect
